// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_STROLLER_SEARCH = "Podrobn\u00e9 h\u013eadanie - N\u00e1jdi svoj vysn\u00edvan\u00fd ko\u010d\u00edk";
export const STROLLERS_COMPARISON = "Porovnaj";
export const STROLLER_SEARCH_SUBMIT = "Zobraz";
export const STROLLER_SEARCH_TITLE = "H\u013eadanie";
export const STROLLERS_SEARCH_RESULTS_results = "Ko\u010d\u00edky: %(results)s ";
